export const replaceCommaByDotWithToFixed = (value, toFixedValue = 1) =>
  String(Number.parseFloat(value).toFixed(toFixedValue)).replace('.', ',');
